import { createUIDefinition } from '../default-task-definition'
import * as taskName from './task-name'
import * as processUI from '../../process-ui'


export default createUIDefinition({
    taskName: taskName.ORDER_ALIGNER,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/order-aligner.js